import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({name: 'timecardHalfFullDayFormat'})
export class TimecardHalfFullDayFormatPipe implements PipeTransform {

  constructor(private Translate: TranslateService) {
  }

  transform(timecard: Timecard | TimecardDetails, hours: number): string {
    if (hours > 0 && hours <= 4) {
      return this.Translate.instant('timecards.half-day');
    } else if (hours > 4) {
      return this.Translate.instant('timecards.full-day');
    } else {
      return '';
    }
  }
}
